// useCloseOnBack — enquanto `active`, o voltar do celular chama `onBack` em vez de sair da tela.
// Lógica e o porquê: utils/backButtonLayers.js.
//
// Uso típico numa janela de tela cheia:
//   useCloseOnBack(open && fullScreen, onClose);
// `onBack` devolve `true` quando resolveu por dentro e a janela continua aberta (o voltar seguinte chega nela de novo).
//
// Devolve `isOnTop()`: navegar para outra tela DE DENTRO da janela deve usar `navigate(href, { replace: isOnTop() })`
// — troca a entrada da janela pela tela de destino; voltar dali cai na tela de antes, sem passo morto.
import { useCallback, useEffect, useRef } from 'react';
import { backButtonLayers } from '../utils/backButtonLayers';

export function useCloseOnBack(active, onBack) {
  const onBackRef = useRef(onBack);
  useEffect(() => { onBackRef.current = onBack; }, [onBack]);

  const handleRef = useRef(null);
  useEffect(() => {
    if (!active || !backButtonLayers) return undefined;
    const handle = backButtonLayers.add(() => onBackRef.current?.());
    handleRef.current = handle;
    return () => {
      handleRef.current = null;
      handle.release();
    };
  }, [active]);

  return useCallback(() => !!handleRef.current?.isCurrent(), []);
}
